import { orderItemKey, orderItemReference } from '../../../../utils/orderItemKeys';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import $ from 'jquery';
import { getApiErrorText } from '../../../../utils/apiResponse';
import { orderQuantityLimit, orderReadyForShipment, isOrderItemAwaitingStock } from '../../../../utils/stockQuantities';
import { checkIsAdminLoggined } from '../../../../utils/utils';
import {
  fetchOrderStatuses,
  fetchPaymentStatuses,
  fetchPaymentTypes,
  fetchProductOrderStatuses,
  fetchProductOrderTypes, fetchReceiveMethods,
} from '../../../../utils/apiUtils';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import Header from '../../../Header';
import Footer from '../../../Footer';
import {
  isPreorderLikeOrderStatusDb,
  generateOrderText, generatePreorderText, generatePreorderSoonText, generateDeliveryConfirmationText, handleOrderStatusChange,
  handlePaymentStatusChange, handlePaymentTypeChange, renderPrice,
} from '../../../../utils/adminOrderService';
import { toDateInputValue } from '../../../../utils/utils';
import {
  buildApplyDiscountQuery,
  calcPercentDiscountedPrice,
  parseDiscountPercent,
  resolveDiscountUserIdentity,
} from '../../../../utils/adminDiscount';
import { downloadOrderItemsExcel } from '../../../../utils/orderItemsExcelExport';
import {
  buildBuyerFromOrder,
  downloadOrderInvoiceFromOrder,
} from '../../../../utils/orderInvoiceExcelExport';
import { BASE_URL } from '../../../../shared/constants';
import AdminCommentModal from '../../AdminCommentModal';
import InvoiceBuyerModal from './InvoiceBuyerModal';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Alert from '../../Alert';
import NovaPostCityInput from '../../NovaPostCityInput';
import NovaPostDepartmentInput from '../../NovaPostDepartmentInput';
import NovaPostAddressInput from '../../NovaPostAddressInput';
import AttachUserModal from '../../AttachUserModal';
import AdminOrderDesktopView from './AdminOrderDesktopView';
import AdminOrderMobileView from './AdminOrderMobileView';
import AdminOrderScannerPickModal from './AdminOrderScannerPickModal';
import BulkOrderDiscountModal from './BulkOrderDiscountModal';
import TransferOrderItemsModal from './TransferOrderItemsModal';
import '../../../../styles/common.css';


const AdminOrderPage = props => {
  const { orderId } = useParams();
  const history = useHistory();

  const token = localStorage.getItem('token');

  //enums
  const [orderStatusesEnum, setOrderStatusesEnum] = useState([]);
  const [paymentTypesEnum, setPaymentTypesEnum] = useState([]);
  const [paymentStatusesEnum, setPaymentStatusesEnum] = useState([]);
  const [poProductOrderTypeEnum, setPoProductOrderTypeEnum] = useState([]);
  const [poProductStatusEnum, setPoProductStatusEnum] = useState([]);

  const [order, setOrder] = useState(null);

  const [modalImage, setModalImage] = useState('');
  let [selectedItem, setSelectedItem] = useState(null);
  const purchasePriceLocked = order?.orderStatus?.databaseValue !== 'SENT' && isOrderItemAwaitingStock(selectedItem);
  const [editedUserInfo, setEditedUserInfo] = useState(null);

  const [successAPIMessage, setSuccessAPIMessage] = useState('');
  const [successAPIMessageModal, setSuccessAPIMessageModal] = useState('');
  const [errorAPIMessage, setErrorAPIMessage] = useState('');
  const [errorAPIMessageModal, setErrorAPIMessageModal] = useState('');

  const [showUserComment, setShowUserComment] = useState(false);
  const [showAdminComment, setShowAdminComment] = useState(false);
  const [showMaxQuantityTooltip, setShowMaxQuantityTooltip] = useState(false);
  const [disableButtons, setDisableButtons] = useState(false);

  const [adminComment, setAdminComment] = useState(false);
  const [percentDiscountOnProduct, setPercentDiscountOnProduct] = useState('');
  const [flatDiscountOnProduct, setFlatDiscountOnProduct] = useState('');

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [generatedToClipboardTextOrderId, setGeneratedToClipboardTextOrderId] = useState('');
  const [generatedPreorderTextOrderId, setGeneratedPreorderTextOrderId] = useState('');
  const [generatedPreorderSoonTextOrderId, setGeneratedPreorderSoonTextOrderId] = useState('');
  const [generatedDeliveryConfirmationTextOrderId, setGeneratedDeliveryConfirmationTextOrderId] = useState('');
  const [isSuccessfullyDeleted, setIsSuccessfullyDeleted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDeletingShipment, setIsDeletingShipment] = useState(false);
  const [deleteShipmentResult, setDeleteShipmentResult] = useState(null);
  const [showScannerPickModal, setShowScannerPickModal] = useState(false);

  const [selectedOrderItemKeys, setSelectedOrderItemKeys] = useState([]);
  const [showSelectedDropdown, setShowSelectedDropdown] = useState(false);
  const [transferRequest, setTransferRequest] = useState(null);
  const [paymentRefreshKey, setPaymentRefreshKey] = useState(0);
  const [showBulkDiscountModal, setShowBulkDiscountModal] = useState(false);
  const [showInvoiceBuyerModal, setShowInvoiceBuyerModal] = useState(false);
  const [isExportingOrderInvoice, setIsExportingOrderInvoice] = useState(false);
  const [invoiceExportError, setInvoiceExportError] = useState('');
  const [bulkForceDiscount, setBulkForceDiscount] = useState(false);
  const [bulkDiscountPercent, setBulkDiscountPercent] = useState('');
  const [bulkDiscountUserSearchQuery, setBulkDiscountUserSearchQuery] = useState('');
  const [bulkDiscountSelectedUser, setBulkDiscountSelectedUser] = useState(null);
  const [bulkDiscountLevelsList, setBulkDiscountLevelsList] = useState([]);
  const [bulkSelectedDiscountLevel, setBulkSelectedDiscountLevel] = useState('');
  const [bulkDiscountLoading, setBulkDiscountLoading] = useState(false);
  const [bulkDiscountMessage, setBulkDiscountMessage] = useState('');
  const [bulkDiscountErrorMessage, setBulkDiscountErrorMessage] = useState('');

  const [packagingBoxesOptions, setPackagingBoxesOptions] = useState([]);
  const [places, setPlaces] = useState([{ selectedBox: null, isCustom: false, dropdownOpen: false }]);
  const [deliveryPayer, setDeliveryPayer] = useState('Recipient');
  const [shipmentDescription, setShipmentDescription] = useState('');
  const isCardPaymentType = (paymentTypeDb) =>
    paymentTypeDb === 'CREDIT_CARD' || paymentTypeDb === 'PROM_PAYMENT' || paymentTypeDb === 'PROM_PAY_BY_PARTS';
  const isFreeShippingBySender = (orderToCheck) => {
    const sum = (orderToCheck?.discountedPrice ?? orderToCheck?.price ?? 0);
    const paymentDb = orderToCheck?.paymentType?.databaseValue;
    return Number(sum) >= 2000 && isCardPaymentType(paymentDb);
  };
  const isDeliveryPayerLocked = Boolean(order && isFreeShippingBySender(order));
  const setDeliveryPayerIfAllowed = (next) => {
    if (isDeliveryPayerLocked) return;
    setDeliveryPayer(next);
  };

  const setPlace = (placeIndex, updates) => {
    setPlaces(prev => prev.map((p, i) => i === placeIndex ? { ...p, ...updates } : p));
  };
  const addPlace = () => {
    setPlaces(prev => [...prev, { selectedBox: null, isCustom: false, dropdownOpen: false }]);
  };
  const removePlace = (placeIndex) => {
    if (places.length <= 1) return;
    setPlaces(prev => prev.filter((_, i) => i !== placeIndex));
  };
  const getEffectiveBox = (place) => {
    const hasCustom = place.isCustom && place.selectedBox && place.selectedBox.length != null && place.selectedBox.width != null && place.selectedBox.height != null;
    if (hasCustom) return place.selectedBox;
    if (place.selectedBox && place.selectedBox.id != null) return place.selectedBox;
    return null;
  };

  const [receiveMethods, setReceiveMethods] = useState([]);
  const [selectedReceiveMethod, setSelectedReceiveMethod] = useState(null);


  useEffect(() => {
    checkIsAdminLoggined(props);
    window.scrollTo(0, 0);
    fetchOrderStatuses(token, setOrderStatusesEnum);
    fetchPaymentTypes(token, setPaymentTypesEnum);
    fetchPaymentStatuses(token, setPaymentStatusesEnum);
    fetchProductOrderTypes(token, setPoProductOrderTypeEnum);
    fetchProductOrderStatuses(token, setPoProductStatusEnum);
    fetchReceiveMethods(token, setReceiveMethods);
    getOrderInfo();
    getPackagingBoxes();
    axios.get('/api/v1/user/discount-level', { headers: { Authorization: token } })
      .then((res) => {
        const data = res.data?.data;
        setBulkDiscountLevelsList(Array.isArray(data) ? data : []);
      })
      .catch(() => setBulkDiscountLevelsList([]));
  }, []);

  useEffect(() => {
    setSelectedOrderItemKeys([]);
    setShowSelectedDropdown(false);
    setShowBulkDiscountModal(false);
    setTransferRequest(null);
  }, [orderId]);

  useEffect(() => {
    const items = order?.orderItems;
    if (!items) {
      setSelectedOrderItemKeys([]);
      return;
    }
    const validIds = new Set(items.map((item) => orderItemKey(item)));
    setSelectedOrderItemKeys((prev) => {
      const next = prev.filter((id) => validIds.has(id));
      return next.length === prev.length ? prev : next;
    });
  }, [order?.orderItems]);

  useEffect(() => {
    const el = document.getElementById('selectWeightModal');
    if (!el) return;
    const onShown = () => {
      setPlaces([{ selectedBox: null, isCustom: false, dropdownOpen: false }]);
      setSuccessAPIMessage('');
      setErrorAPIMessage('');
    };
    const onHidden = () => {
      setPlaces([{ selectedBox: null, isCustom: false, dropdownOpen: false }]);
      setSuccessAPIMessage('');
      setErrorAPIMessage('');
    };
    el.addEventListener('shown.bs.modal', onShown);
    el.addEventListener('hidden.bs.modal', onHidden);
    return () => {
      el.removeEventListener('shown.bs.modal', onShown);
      el.removeEventListener('hidden.bs.modal', onHidden);
    };
  }, [order]);

  const getOrderInfo = () => {
    return axios
      .get('/api/v1/order/' + orderId, {
        headers: {
          Authorization: token,
        },
      })
      .then(res => {
        if (res.status === 200) {
          setOrder(res.data.data);
          return res.data.data;
        }
      }).catch(function() {
        setOrder(null);
    });
  };

  const getPackagingBoxes = () => {
    axios
      .get('/api/v1/packaging-boxes', {
        headers: {
          Authorization: token,
        },
      })
      .then(res => {
        if (res.status === 200) {
          setPackagingBoxesOptions(res.data.data);
        }
      })
      .catch(function (error) {
        console.error('Error fetching packaging boxes:', error);
      });
  };

  const refreshEditedItem = async (snapshot, status) => {
    const latest = await getOrderInfo();
    const key = orderItemKey({ ...snapshot, productStatus: status });
    const item = latest?.orderItems?.find(row => orderItemKey(row) === key);
    if (item) {
      setSelectedItem(previous =>
        previous?.productId === snapshot.productId && previous.originalProductStatus === snapshot.originalProductStatus
          ? { ...item, originalProductStatus: orderItemReference(item).productStatus,
              purchasePriceEdited: false,
              maxQuantity: orderQuantityLimit(item, latest.orderStatus) }
          : previous,
      );
    }
  };

  const updateProductOrder = () => {
    setDisableButtons(true);
    const token = localStorage.getItem('token');

    const requestData = {
      orderId: order.orderId,
      productId: selectedItem.productId,
      currentProductStatus: selectedItem.originalProductStatus,
      price: selectedItem.price,
      discountedPrice: selectedItem.discountedPrice,
      purchasePrice: selectedItem.purchasePriceEdited && !purchasePriceLocked
        ? selectedItem.purchasePrice : null,
      quantity: selectedItem.quantity,
      promCommission: selectedItem.promCommission,
      productOrderType: selectedItem.productOrderType ? selectedItem.productOrderType.databaseValue : null,
      productStatus: selectedItem.productStatus ? selectedItem.productStatus.databaseValue : null,
      clearExpectedArrivalDate: selectedItem.expectedArrivalDate === '',
      expectedArrivalDate: (() => {
        const v = selectedItem.expectedArrivalDate;
        if (v == null || v === '') return null;
        const s = toDateInputValue(v);
        return s !== '' ? s : null;
      })(),
    };

    axios
      .put('/api/v1/order/product-order', requestData, {
        headers: {
          Authorization: token,
        },
      })
      .then(async () => {
        setSuccessAPIMessageModal('Дані успішно оновлені');
        setErrorAPIMessageModal('');
        await refreshEditedItem(selectedItem, selectedItem.productStatus);
        setDisableButtons(false);
      })
      .catch(error => {
        console.error('Error updating product order:', error);
        setErrorAPIMessageModal(getApiErrorText(error, 'Не вдалося зберегти зміни'));
        setSuccessAPIMessageModal('');
        setDisableButtons(false);
      });
  };

  const updateProductOrderQuantity = (newQuantity) => {
    setDisableButtons(true);
    const isDelete = newQuantity === 0;
    const token = localStorage.getItem('token');

    const requestData = {
      orderId: order.orderId,
      productId: selectedItem.productId,
      currentProductStatus: selectedItem.originalProductStatus,
      quantity: newQuantity
    };

    axios
      .put('/api/v1/order/product-order/quantity', requestData, {
        headers: {
          Authorization: token,
        },
      })
      .then(async response => {
        if (response.data?.data?.orderDeleted) {
          $('#confirmDeleteModal, #editQuantityModal').modal('hide');
          history.replace('/admin/orders/new');
          return;
        }
        setSuccessAPIMessageModal(isDelete ? 'Товар успішно видалено' : 'Кількість успішно змінена');
        setErrorAPIMessageModal('');
        await refreshEditedItem(selectedItem, selectedItem.originalProductStatus);
        setDisableButtons(false);
        setIsSuccessfullyDeleted(isDelete);
      })
      .catch(error => {
        console.error('Error updating product order:', error);
        setErrorAPIMessageModal(getApiErrorText(error, 'Не вдалося зберегти зміни'));
        setSuccessAPIMessageModal('');
        setDisableButtons(false);
      });
  };

  const updateDeliveryDetails = () => {
    setDisableButtons(true);
    const token = localStorage.getItem('token');
    const requestData = {
      orderId: order.orderId,
      receiveMethodId: selectedReceiveMethod.id,
      userInfoId: editedUserInfo.id,
      name: editedUserInfo.name,
      surname: editedUserInfo.surname,
      phone: editedUserInfo.phone,
      city: editedUserInfo.city || null,
      departmentNumber: editedUserInfo.departmentNumber || null,
      novaPostCityRef: editedUserInfo.novaPostCityRef || null,
      novaPostAddressRef: editedUserInfo.novaPostAddressRef || null,
      street: editedUserInfo.street || null,
      novaPostStreetRef: editedUserInfo.novaPostStreetRef || null,
      buildingNumber: editedUserInfo.buildingNumber || null,
      flatNumber: editedUserInfo.flatNumber || null,
    };

    axios.put('/api/v1/user/user-info', requestData, {
      headers: {
        Authorization: token,
      },
    })
      .then(() => {
        setSuccessAPIMessageModal('Дані успішно оновлено');
        setErrorAPIMessageModal('');
        getOrderInfo();
        setDisableButtons(false);
        // Автоматично приховуємо повідомлення через 5 секунд
        setTimeout(() => {
          setSuccessAPIMessageModal('');
        }, 5000);
      })
      .catch(() => {
        setSuccessAPIMessageModal('');
        setErrorAPIMessageModal('Не вдалося оновити дані');
        setDisableButtons(false);
        // Автоматично приховуємо повідомлення про помилку через 5 секунд
        setTimeout(() => {
          setErrorAPIMessageModal('');
        }, 5000);
      });
  }


  const createShipment = () => {
    setIsLoading(true);
    const packagingParameters = places.map((place) => {
      const effectiveBox = getEffectiveBox(place);
      return effectiveBox ? {
        packagingBoxId: effectiveBox.id || null,
        weight: effectiveBox.weight,
        length: effectiveBox.length,
        width: effectiveBox.width,
        height: effectiveBox.height
      } : null;
    }).filter(Boolean);
    const invalid = packagingParameters.some(p => p.length == null || p.width == null || p.height == null);
    if (packagingParameters.length === 0 || invalid) {
      setErrorAPIMessage('Оберіть пакування або введіть габарити вручну для кожного місця');
      setIsLoading(false);
      return;
    }
    setErrorAPIMessage('');

    if (!readyForShipment) {
      setErrorAPIMessage('Замовлення не повністю забезпечене товаром на складі');
      setIsLoading(false);
      return;
    }

    const requestData = {
      orderId: order.orderId,
      payerType: deliveryPayer,
      description: shipmentDescription || undefined,
      packagingParameters
    };


    axios.post(`/api/v1/delivery-service/nova-post/shipment`, requestData, {
      headers: {
        Authorization: token,
      },
    })
      .then(() => {
        setSuccessAPIMessage("ТТН успішно сформована");
        setErrorAPIMessage('');
        setIsLoading(false);
        getOrderInfo();
        const closeBtn = document.querySelector('#selectWeightModal button[data-dismiss="modal"]');
        if (closeBtn) {
          closeBtn.click();
        }
      })
      .catch(error => {
        console.log("error = ", error);
        setSuccessAPIMessage("");
        setErrorAPIMessage(getApiErrorText(error, 'Не вдалося створити ТТН'));
        setIsLoading(false);
        console.error('Error creating shipment', error);
      });
  };

  const handleCustomBoxChange = (placeIndex, e) => {
    const { name, value } = e.target;
    const parsed = value === '' ? undefined : (name === 'weight' ? parseFloat(value) : parseInt(value, 10));
    setPlace(placeIndex, { selectedBox: { ...(places[placeIndex].selectedBox || {}), [name]: isNaN(parsed) ? undefined : parsed } });
  };

  const handleEditProductOrderButtonClick = (item) => {
    let maxQuantity = orderQuantityLimit(item, order?.orderStatus?.databaseValue);
    setSelectedItem({
      ...item,
      originalProductStatus: orderItemReference(item).productStatus,
      purchasePriceEdited: false,
      maxQuantity: maxQuantity
    });
    setShowMaxQuantityTooltip(false);
    setSuccessAPIMessageModal('');
    setErrorAPIMessageModal('');
    setIsSuccessfullyDeleted(false);
    setPercentDiscountOnProduct('');
    setFlatDiscountOnProduct('');
  };

  // Функція для очищення номера телефону від пробілів, дужок, + та префіксу 38
  const cleanPhoneNumber = (value) => {
    if (!value) return '';
    
    // Видаляємо всі пробіли, дужки, тире, плюси
    let cleaned = value.replace(/[\s()+-]/g, '');
    
    // Якщо починається з 38 і після нього рівно 10 цифр, видаляємо 38
    if (cleaned.startsWith('38') && cleaned.length === 12 && /^38\d{10}$/.test(cleaned)) {
      cleaned = cleaned.substring(2);
    }
    
    return cleaned;
  };

  const handlePhoneNumberChange = (e) => {
    const cleanedValue = cleanPhoneNumber(e.target.value);
    setEditedUserInfo({ ...editedUserInfo, phone: cleanedValue });
  };

  const handleEditDeliveryInfoButtonClick = () => {
    const ui = order.userInfo;
    setEditedUserInfo({
      ...ui,
      novaPostDeliveryCityRef: ui.novaPostDeliveryCityRef || '',
    });
    setSelectedReceiveMethod(order.userInfo.receiveMethod);
    setSuccessAPIMessageModal('');
    setErrorAPIMessageModal('');
  }

  const calculateDiscount = (percentDiscount, flatDiscount) => {
    if (selectedItem === undefined || selectedItem === null) {
      return;
    }
    const price = selectedItem.price;
    const newDiscountedPrice = flatDiscount && flatDiscount > 0 ? price - flatDiscount
      : Math.ceil(price - ((price * percentDiscount) / 100));
    setSelectedItem({
      ...selectedItem,
      discountedPrice: newDiscountedPrice
    });
  }

  const onChangeQuantity = (add) => {
    const resultQuantity = Number(selectedItem.quantity) + (add ? 1 : -1);

    if (resultQuantity >= 1 && resultQuantity <= selectedItem.maxQuantity) {
      setSelectedItem({
        ...selectedItem,
        quantity: resultQuantity
      });
    }

    setShowMaxQuantityTooltip(resultQuantity > selectedItem.maxQuantity);
  }

  const handleConfirmProductOrderEdit = () => {
    updateProductOrder();
  };

  const handleConfirmProductOrderQuantityEdit = () => {
    updateProductOrderQuantity(selectedItem.quantity);
  };

  const handleConfirmDeleteProductOrder = () => {
    updateProductOrderQuantity(0);
  };

  const handleConfirmDeliveryEdit = () => {
    updateDeliveryDetails();
  };

  const toggleSelectOrderItem = (productId) => {
    setSelectedOrderItemKeys((prev) =>
      prev.includes(productId) ? prev.filter((id) => id !== productId) : [...prev, productId]
    );
  };

  const selectAllOrderItems = () => {
    if (!order?.orderItems?.length) return;
    const ids = order.orderItems.map((item) => orderItemKey(item));
    const allSelected = ids.every((id) => selectedOrderItemKeys.includes(id));
    setSelectedOrderItemKeys(allSelected ? [] : ids);
  };

  const clearOrderItemSelection = () => {
    setSelectedOrderItemKeys([]);
    setShowSelectedDropdown(false);
  };

  const exportOrderItemsExcel = () => {
    if (!order?.orderItems?.length) return;
    const items = selectedOrderItemKeys.length > 0
      ? order.orderItems.filter((item) => selectedOrderItemKeys.includes(orderItemKey(item)))
      : order.orderItems;
    if (!items.length) return;
    downloadOrderItemsExcel({ orderId: order.orderId, items });
  };

  const exportOrderInvoice = () => {
    if (!order?.orderItems?.length) return;
    const hasSelection = selectedOrderItemKeys.length > 0;
    if (hasSelection) {
      const items = order.orderItems.filter((item) => selectedOrderItemKeys.includes(orderItemKey(item)));
      if (!items.length) return;
    }
    setInvoiceExportError('');
    setShowInvoiceBuyerModal(true);
  };

  const confirmOrderInvoiceExport = async ({ buyer, bankAccount }) => {
    if (!order || isExportingOrderInvoice) return;
    const hasSelection = selectedOrderItemKeys.length > 0;
    setIsExportingOrderInvoice(true);
    setInvoiceExportError('');
    try {
      await downloadOrderInvoiceFromOrder({
        order,
        selectedOrderItemKeys: hasSelection ? selectedOrderItemKeys : undefined,
        buyer,
        bankAccount,
      });
      setShowInvoiceBuyerModal(false);
    } catch (error) {
      console.error('Failed to export order invoice:', error);
      setInvoiceExportError(error?.message || 'Не вдалося сформувати рахунок');
    } finally {
      setIsExportingOrderInvoice(false);
    }
  };

  const openBulkDiscountModal = ({ forAll = false } = {}) => {
    if (forAll) {
      if (!order?.orderItems?.length) return;
      setSelectedOrderItemKeys(order.orderItems.map((item) => orderItemKey(item)));
    }
    setBulkForceDiscount(false);
    setBulkDiscountPercent('');
    setBulkDiscountUserSearchQuery('');
    setBulkDiscountSelectedUser(null);
    setBulkSelectedDiscountLevel('');
    setBulkDiscountMessage('');
    setBulkDiscountErrorMessage('');
    setShowBulkDiscountModal(true);
  };

  const onBulkDiscountUserSearchQueryChange = (query) => {
    setBulkDiscountSelectedUser(null);
    setBulkDiscountUserSearchQuery(query);
  };

  const onBulkDiscountUserSelect = (user) => {
    setBulkDiscountSelectedUser(user);
    setBulkDiscountUserSearchQuery('');
  };

  const onBulkDiscountUserClear = () => {
    setBulkDiscountSelectedUser(null);
    setBulkDiscountUserSearchQuery('');
  };

  const persistDiscountedPrices = async (itemsWithNewPrices) => {
    await axios.put(
      '/api/v1/order/product-order/bulk',
      {
        orderId: order.orderId,
        selectedItems: itemsWithNewPrices.map(({ item }) => orderItemReference(item)),
        items: itemsWithNewPrices.map(({ item, discountedPrice }) => ({
          productId: item.productId,
          currentProductStatus: orderItemReference(item).productStatus,
          discountedPrice,
        })),
      },
      { headers: { Authorization: token } }
    );
  };

  const applyBulkDiscount = async () => {
    if (!order?.orderItems?.length || selectedOrderItemKeys.length === 0) return;

    const selectedItems = order.orderItems.filter((item) => selectedOrderItemKeys.includes(orderItemKey(item)));
    if (selectedItems.length === 0) {
      setBulkDiscountErrorMessage('Обрані товари більше не в замовленні');
      clearOrderItemSelection();
      return;
    }

    const userIdentity = resolveDiscountUserIdentity(bulkDiscountSelectedUser, bulkDiscountUserSearchQuery);
    if (bulkDiscountPercent === '' && userIdentity === '' && bulkSelectedDiscountLevel === '') {
      setBulkDiscountMessage('');
      setBulkDiscountErrorMessage('Введіть знижку у відсотках, оберіть клієнта або рівень знижки');
      return;
    }

    setBulkDiscountLoading(true);
    setBulkDiscountMessage('');
    setBulkDiscountErrorMessage('');

    try {
      if (bulkDiscountPercent !== '') {
        const parsed = parseDiscountPercent(bulkDiscountPercent);
        if (!parsed.ok) {
          setBulkDiscountErrorMessage('Знижка повинна бути в діапазоні від 0 до 100');
          setBulkDiscountPercent('');
          setBulkDiscountLoading(false);
          return;
        }
        const { percent } = parsed;
        const updates = selectedItems.map((item) => ({
          item,
          discountedPrice: calcPercentDiscountedPrice(
            item.price,
            item.discountedPrice,
            percent,
            bulkForceDiscount
          ),
        }));
        await persistDiscountedPrices(updates);
        setBulkDiscountMessage(`Встановлено знижку ${percent}%`);
        setBulkDiscountPercent('');
        setBulkDiscountUserSearchQuery('');
        setBulkDiscountSelectedUser(null);
        setBulkSelectedDiscountLevel('');
        getOrderInfo();
        clearOrderItemSelection();
        setShowBulkDiscountModal(false);
        setAlertMessage(`Встановлено знижку ${percent}% для ${updates.length} товарів`);
        setShowAlert(true);
        setBulkDiscountLoading(false);
        return;
      }

      const productsPayload = selectedItems.map((item) => ({
        id: item.productId,
        price: item.price,
        discountedPrice: bulkForceDiscount ? null : item.discountedPrice,
      }));

      const appliedLevel = bulkSelectedDiscountLevel;
      const query = buildApplyDiscountQuery({
        discountLevel: bulkSelectedDiscountLevel,
        userIdentity,
      });

      const res = await axios.post('/api/v1/user/apply-discount?' + query, productsPayload, {
        headers: { Authorization: token },
      });

      const discountedProducts = res.data?.data?.products || [];
      const updates = selectedItems.map((item, index) => {
        const updated = discountedProducts[index];
        return {
          item,
          discountedPrice: updated?.discountedPrice != null ? updated.discountedPrice : item.discountedPrice,
        };
      });
      await persistDiscountedPrices(updates);

      const levelForMessage = appliedLevel !== ''
        ? appliedLevel
        : (res.data.data?.discountInfoDto?.level != null ? res.data.data.discountInfoDto.level : null);
      const levelMsg = levelForMessage != null
        ? 'Враховано ' + levelForMessage + ' рівень знижки. '
        : '';
      setBulkDiscountMessage(levelMsg + 'Вартість товарів успішно перерахована.');
      setBulkDiscountUserSearchQuery('');
      setBulkDiscountSelectedUser(null);
      setBulkDiscountPercent('');
      setBulkSelectedDiscountLevel('');
      getOrderInfo();
      clearOrderItemSelection();
      setShowBulkDiscountModal(false);
      setAlertMessage(levelMsg + `Вартість ${updates.length} товарів успішно перерахована.`);
      setShowAlert(true);
    } catch (error) {
      setBulkDiscountErrorMessage(error.response?.data?.errorMessage || 'Помилка застосування знижки');
      setBulkDiscountMessage('');
    } finally {
      setBulkDiscountLoading(false);
    }
  };


  const confirmDeleteShipment = () => {
    if (!order?.trackingNumber) return;
    setIsDeletingShipment(true);
    setDeleteShipmentResult(null);
    axios.delete(`/api/v1/delivery-service/nova-post/shipment/${order.orderId}`, {
      headers: { Authorization: token },
    })
      .then((response) => {
        const message = response.data?.data?.message ?? 'Накладну видалено';
        setDeleteShipmentResult({ success: true, message });
        getOrderInfo();
        setIsDeletingShipment(false);
      })
      .catch((err) => {
        const msg = err.response?.data?.data ?? err.response?.data?.errorMessage ?? 'Не вдалося видалити накладну';
        setDeleteShipmentResult({ success: false, message: typeof msg === 'string' ? msg : 'Не вдалося видалити накладну' });
        setIsDeletingShipment(false);
      });
  };

  const closeDeleteShipmentModal = () => {
    setDeleteShipmentResult(null);
  };

  const detachOrderFromUser = () => {
    setDisableButtons(true);
    axios.delete(`/api/v1/order/${order.orderId}/user`, {
      headers: {
        Authorization: token,
      },
    })
      .then(() => {
        setSuccessAPIMessage('Користувача відкріплено від замовлення');
        setErrorAPIMessage('');
        getOrderInfo();
        setDisableButtons(false);
        // Автоматично приховуємо повідомлення через 2 секунди
        setTimeout(() => {
          setSuccessAPIMessage('');
        }, 2000);
      })
      .catch(() => {
        setSuccessAPIMessage('');
        setErrorAPIMessage('Не вдалося відкріпити користувача');
        setDisableButtons(false);
        // Автоматично приховуємо повідомлення про помилку через 2 секунди
        setTimeout(() => {
          setErrorAPIMessage('');
        }, 2000);
      });
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setAlertMessage("Додано в буфер обміну");
      setShowAlert(true);
      setGeneratedToClipboardTextOrderId('');
      setGeneratedPreorderTextOrderId('');
      setGeneratedPreorderSoonTextOrderId('');
      setGeneratedDeliveryConfirmationTextOrderId('');
    }, (err) => {
      console.error('Could not copy text: ', err);
    });
  };

  const generateOrderTextToClipboard = (order) => {
    let text = generateOrderText(order);

    navigator.clipboard.writeText(text);
    setGeneratedToClipboardTextOrderId(order.orderId);
    setGeneratedPreorderTextOrderId('');
    setGeneratedPreorderSoonTextOrderId('');
    setGeneratedDeliveryConfirmationTextOrderId('');

    setAlertMessage('Повідомлення успішно згенеровано і додано в буфер обміну');
    setShowAlert(true);
  };

  const generatePreorderTextToClipboard = (order) => {
    let text = generatePreorderText(order);

    navigator.clipboard.writeText(text);
    setGeneratedPreorderTextOrderId(order.orderId);
    setGeneratedToClipboardTextOrderId('');
    setGeneratedPreorderSoonTextOrderId('');
    setGeneratedDeliveryConfirmationTextOrderId('');

    setAlertMessage('Повідомлення про передзамовлення успішно згенеровано і додано в буфер обміну');
    setShowAlert(true);
  };

  const generatePreorderSoonTextToClipboard = (order) => {
    let text = generatePreorderSoonText(order);

    navigator.clipboard.writeText(text);
    setGeneratedPreorderSoonTextOrderId(order.orderId);
    setGeneratedToClipboardTextOrderId('');
    setGeneratedPreorderTextOrderId('');
    setGeneratedDeliveryConfirmationTextOrderId('');

    setAlertMessage('Повідомлення про передзамовлення (майже в наявності) успішно згенеровано і додано в буфер обміну');
    setShowAlert(true);
  };

  const generateDeliveryConfirmationTextToClipboard = (order) => {
    let text = generateDeliveryConfirmationText(order);

    navigator.clipboard.writeText(text);
    setGeneratedDeliveryConfirmationTextOrderId(order.orderId);
    setGeneratedToClipboardTextOrderId('');
    setGeneratedPreorderTextOrderId('');
    setGeneratedPreorderSoonTextOrderId('');

    setAlertMessage('Повідомлення про підтвердження доставки успішно згенеровано і додано в буфер обміну');
    setShowAlert(true);
  };

  const handleReceiveMethodChange = (event) => {
    const selectedValue = parseInt(event.target.value);
    const selectedMethod = receiveMethods.find(method => method.id === selectedValue);
    setSelectedReceiveMethod(selectedMethod);
    if (selectedMethod) {
      if (selectedValue === 1) {
        setEmptyAddress();
      } else if (selectedValue === 2) {
        setEmptyCityAndDepartmentNumber();
      } else if (selectedValue === 3) {
        setEmptyCityAndDepartmentNumberAndAddress();
      }
    }
  };

  const setEmptyCityAndDepartmentNumber = () => {
    setEditedUserInfo(prev => ({
      ...prev,
      city: '',
      novaPostCityRef: '',
      novaPostDeliveryCityRef: '',
      departmentNumber: '',
      novaPostAddressRef: ''
    }));
  };

  const setEmptyAddress = () => {
    setEditedUserInfo(prev => ({
      ...prev,
      street: '',
      novaPostStreetRef: '',
      buildingNumber: '',
      flatNumber: ''
    }));
  };

  const setEmptyCityAndDepartmentNumberAndAddress = () => {
    setEditedUserInfo(prev => ({
      ...prev,
      city: '',
      novaPostCityRef: '',
      novaPostDeliveryCityRef: '',
      departmentNumber: '',
      novaPostAddressRef: '',
      street: '',
      novaPostStreetRef: '',
      buildingNumber: '',
      flatNumber: ''
    }));
  };

  const renderGenerateMessageToClipboardIcon = () => {
    if (generatedToClipboardTextOrderId !== order.orderId) {
      return (
        <i
          className='bi bi-clipboard-data pl-1'
          style={{ cursor: 'pointer' }}
          onClick={() => generateOrderTextToClipboard(order)}
          title='Згенерувати повне повідомлення про замовлення'
        />
      )
    } else {
      return (
        <i
          className='bi bi-clipboard-check text-success pl-1'
          style={{ cursor: 'pointer' }}
          title='Повідомлення згенеровано'
        />
      )
    }
  }

  const renderGeneratePreorderMessageToClipboardIcon = () => {
    if (!isPreorderLikeOrderStatusDb(order?.orderStatus?.databaseValue)) return null;
    if (generatedPreorderTextOrderId !== order.orderId) {
      return (
        <i
          className='bi bi-calendar-check pl-1'
          style={{ cursor: 'pointer' }}
          onClick={() => generatePreorderTextToClipboard(order)}
          title='Згенерувати текст про передзамовлення'
        />
      )
    } else {
      return (
        <i
          className='bi bi-calendar-check text-success pl-1'
          style={{ cursor: 'pointer' }}
          title='Текст про передзамовлення згенеровано'
        />
      )
    }
  }

  const renderGeneratePreorderSoonMessageToClipboardIcon = () => {
    if (!isPreorderLikeOrderStatusDb(order?.orderStatus?.databaseValue)) return null;
    if (generatedPreorderSoonTextOrderId !== order.orderId) {
      return (
        <i
          className='bi bi-calendar-event pl-1'
          style={{ cursor: 'pointer' }}
          onClick={() => generatePreorderSoonTextToClipboard(order)}
          title='Згенерувати текст про передзамовлення (майже в наявності)'
        />
      )
    } else {
      return (
        <i
          className='bi bi-calendar-event text-success pl-1'
          style={{ cursor: 'pointer' }}
          title='Текст про передзамовлення (майже в наявності) згенеровано'
        />
      )
    }
  }

  const renderGenerateDeliveryConfirmationMessageToClipboardIcon = () => {
    if (generatedDeliveryConfirmationTextOrderId !== order.orderId) {
      return (
        <i
          className='bi bi-truck pl-1'
          style={{ cursor: 'pointer' }}
          onClick={() => generateDeliveryConfirmationTextToClipboard(order)}
          title='Згенерувати текст про підтвердження доставки'
        />
      )
    } else {
      return (
        <i
          className='bi bi-truck text-success pl-1'
          style={{ cursor: 'pointer' }}
          title='Текст про підтвердження доставки згенеровано'
        />
      )
    }
  }

  const renderUserComment = () => {
    return (
      <div>
        {order.userComment && !showUserComment && (
          <span className='cursor-pointer font-weight-bold text-success'
                onClick={() => setShowUserComment(true)}>
                          <i className='bi bi-chat-square-text pr-1' />
                          Коментар клієнта
                          </span>
        )}

        {order.userComment && showUserComment && (
          <div className='card bg-light mt-1'>
            <div className='card-header d-flex justify-content-between align-items-center'>
              <div className='font-weight-bold text-success'>
                <i className='bi bi-chat-square-text pr-1' />
                Коментар клієнта
              </div>
              <span
                className='cursor-pointer'
                onClick={() => setShowUserComment(false)}
              >
                                &times;
                              </span>
            </div>
            <div className='card-body p-2'>
              <span className='card-text' style={{ whiteSpace: 'pre-line' }}>{order.userComment}</span>
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderAdminComment = () => {
    return (
      <div>
        {!order.adminComment && (
          <span className='font-weight-bold cursor-pointer' data-toggle='modal'
                data-target='#adminCommentModal'
                onClick={() => {
                  setAdminComment('');
                }}>
                          <i className='bi bi-chat-square-text pr-1' />Додати коментар
                        </span>
        )}
        {order.adminComment && !showAdminComment && (
          <span className='cursor-pointer font-weight-bold text-danger'
                onClick={() => setShowAdminComment(true)}>
                            <i className='bi bi-chat-square-text pr-1' />
                            Коментар адміністратора
                          </span>
        )}

        {order.adminComment && showAdminComment && (
          <div className='card bg-light mt-1'>
            <div className='card-header d-flex justify-content-between align-items-center'>
              <div className='font-weight-bold text-danger'>
                <i className='bi bi-chat-square-text pr-1' />
                Коментар адміністратора
              </div>
              <span
                className='cursor-pointer'
                onClick={() => setShowAdminComment(false)}
              >
                                &times;
                              </span>
            </div>
            <div className='card-body p-2'>
                              <span className='card-text' style={{ whiteSpace: 'pre-line' }}>
                                {order.adminComment} {' '}
                                <i className='bi bi-pencil-fill cursor-pointer text-dark' data-toggle='modal'
                                   data-target='#adminCommentModal'
                                   onClick={() => {
                                     setAdminComment(order.adminComment);
                                   }} />
                              </span>
            </div>
          </div>
        )}
      </div>
    );
  };



  const readyForShipment = orderReadyForShipment(order);
  const openTransfer = mode => {
    const items = (order?.orderItems || []).filter(item => selectedOrderItemKeys.includes(orderItemKey(item)));
    if (items.length) setTransferRequest({ mode, sourceOrderId: order.orderId, items });
  };
  const availableOrderStatuses = orderStatusesEnum.filter(
    status => readyForShipment || !['SENT', 'WAITING_FOR_SENDING'].includes(status.databaseValue),
  );
  const changeOrderStatus = (currentOrder, value, callback) =>
    handleOrderStatusChange(currentOrder, value, callback, setErrorAPIMessage);
  const changePaymentType = (currentOrder, value, callback) =>
    handlePaymentTypeChange(currentOrder, value, callback, setErrorAPIMessage);
  const changePaymentStatus = (currentOrder, value, callback) =>
    handlePaymentStatusChange(currentOrder, value, callback, setErrorAPIMessage);
  const openCreateShipmentModal = () => {
    if (!readyForShipment) {
      setErrorAPIMessage('Усі товари мають бути на складі перед створенням ТТН');
      return;
    }
    setDeliveryPayer(isFreeShippingBySender(order) ? 'Sender' : 'Recipient');
    setShipmentDescription('Wargame Shop замовлення #' + order.orderId);
    setErrorAPIMessage('');
    setSuccessAPIMessage('');
    setPlaces(previous => previous.map(place => ({ ...place, dropdownOpen: false })));
  };

  const orderItemActions = {
    selectedOrderItemKeys,
    onToggleSelect: toggleSelectOrderItem,
    onSelectAll: selectAllOrderItems,
    onClearSelection: clearOrderItemSelection,
    showSelectedDropdown,
    onToggleSelectedDropdown: setShowSelectedDropdown,
    onCloseSelectedDropdown: () => setShowSelectedDropdown(false),
    onOpenBulkDiscount: openBulkDiscountModal,
    onOpenBulkDiscountForAll: () => openBulkDiscountModal({ forAll: true }),
    onMoveSelected: () => openTransfer('move'),
    onSplitSelected: () => openTransfer('split'),
    onExportExcel: exportOrderItemsExcel,
    onExportInvoice: exportOrderInvoice,
  };


  return (
    <div className='container'>
      <Helmet>
        <title>Деталі замовлення</title>
      </Helmet>

      <div className='row'>
        <div className='col p-0'>
          <Header />
        </div>
      </div>


      <Alert show={showAlert} setShow={setShowAlert} message={alertMessage} timeout={1500} />
      {transferRequest && (
        <TransferOrderItemsModal {...transferRequest}
          orderStatuses={orderStatusesEnum}
          onClose={() => setTransferRequest(null)}
          onTransferred={(targetOrderId, sourceOrderDeleted) => {
            if (sourceOrderDeleted) {
              history.replace(`/admin/order/${targetOrderId}`);
              return;
            }
            setPaymentRefreshKey(value => value + 1);
            clearOrderItemSelection();
            getOrderInfo();
          }}
        />
      )}

      {showScannerPickModal && order && (
        <AdminOrderScannerPickModal
          show={showScannerPickModal}
          onHide={() => {
            setShowScannerPickModal(false);
            getOrderInfo();
          }}
          order={order}
        />
      )}

      {order && (
        <AdminCommentModal
          selectedOrderId={order.orderId}
          adminComment={adminComment}
          setAdminComment={setAdminComment}
          refreshOrders={getOrderInfo}
        />
      )}

      <div className='modal fade' id='imageModal' tabIndex='-1' role='dialog' aria-labelledby='imageModalLabel'
           aria-hidden='true'>
        <div className='modal-dialog modal-dialog-centered modal-lg' role='document'>
          <div className='modal-content'>
            <div className='modal-body'>
              <img src={BASE_URL + '/api/v1/product/image/' + modalImage} alt='Product' className='img-fluid' />
            </div>
          </div>
        </div>
      </div>

      <div className='modal fade' id='changeDiscountModal' tabIndex='-1' role='dialog'
           aria-labelledby='changeDiscountModalLabel'
           aria-hidden='true'>
        <div className='modal-dialog modal-dialog-centered' role='document'>
          <div className='modal-content'>
            <div className='modal-body'>
              {selectedItem && (
                <form>
                  <div className='form-group'>
                    <label>Ціна:</label>
                    <input type='number' className='form-control' value={selectedItem.price}
                           onChange={(e) => setSelectedItem({ ...selectedItem, price: e.target.value })} />
                  </div>
                  <div className='form-group'>
                    <label className='text-center font-weight-bold w-100'>Встановити знижку:</label>
                    <div className="row">
                      <div className="col-6">
                        <label className='d-block'>Відсоток знижки</label>
                        <input
                          type='number'
                          className='form-control'
                          value={percentDiscountOnProduct}
                          onChange={(e) => {
                            setPercentDiscountOnProduct(e.target.value);
                            setFlatDiscountOnProduct('');
                            calculateDiscount(e.target.value, null);
                          }}
                        />
                      </div>
                      <div className="col-6">
                        <label className='d-block'>Знижка в грн</label>
                        <input
                          type='number'
                          className='form-control'
                          value={flatDiscountOnProduct}
                          onChange={(e) => {
                            setFlatDiscountOnProduct(e.target.value);
                            setPercentDiscountOnProduct('');
                            calculateDiscount(null, e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='form-group'>
                    <label>Ціна зі знижкою:</label>
                    <input type='number' className='form-control' value={selectedItem.discountedPrice}
                           onChange={(e) => setSelectedItem({ ...selectedItem, discountedPrice: e.target.value })} />
                  </div>
                </form>
              )}
              <div>
                {successAPIMessageModal && <div className='alert alert-success mb-0' role='alert'>{successAPIMessageModal}</div>}
                {errorAPIMessageModal && <div className='alert alert-danger mb-0' role='alert'>{errorAPIMessageModal}</div>}
              </div>
            </div>
            <div className='modal-footer'>
              <button type='button' className='btn btn-secondary' data-dismiss='modal'>Закрити</button>
              <button type='button' className='btn btn-success' onClick={() => handleConfirmProductOrderEdit()}
                      disabled={disableButtons}>
                Застосувати знижку
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className='modal fade' id='confirmDeleteModal' tabIndex='-1' role='dialog'
           aria-labelledby='confirmDeleteModalLabel'
           aria-hidden='true'>
        <div className='modal-dialog modal-dialog-centered' role='document'>
          <div className='modal-content'>
            <div className='modal-body'>
              <p className='font-weight-bold mb-0'>Ви дійсно хочете видалити цей товар з замовлення?</p>
              <p className='text-muted'>
                Невідправлені одиниці повернуться в доступні залишки в межах списаної кількості.
              </p>
              <p className='font-weight-bold text-danger mb-0'>
                Після видалення останнього товару замовлення буде видалено, а його оплати — відкріплено.
              </p>
              <div className='pt-3'>
                {successAPIMessageModal &&
                  <div className='alert alert-success mb-0' role='alert'>{successAPIMessageModal}</div>}
                {errorAPIMessageModal &&
                  <div className='alert alert-danger mb-0' role='alert'>{errorAPIMessageModal}</div>}
              </div>
            </div>
            <div className='modal-footer'>
              <button type='button' className='btn btn-secondary' data-dismiss='modal'>Закрити</button>
              {!isSuccessfullyDeleted && (
                <button type='button' className='btn btn-danger' onClick={() => handleConfirmDeleteProductOrder()}
                        disabled={disableButtons}>
                  Видалити товар
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className='modal fade' id='editQuantityModal' tabIndex='-1' role='dialog'
           aria-labelledby='editQuantityModalLabel' aria-hidden='true'>
        <div className='modal-dialog modal-dialog-centered' role='document'>
          <div className='modal-content'>
            <div className='modal-header justify-content-center'>
              {selectedItem && (
                <h5 className='modal-title font-weight-bold' id='editQuantityModalLabel'>Змінити кількість товару</h5>
              )}
              <button type='button' className='close' data-dismiss='modal' aria-label='Close'
                      style={{ position: 'absolute', right: '15px' }}>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <div className='modal-body'>
              {selectedItem && (
                <div className="d-flex justify-content-center align-items-center">
                  <div className="quantity-selector d-flex align-items-center">
                    <div className="disable-select d-flex align-items-center">
                <span
                  onClick={() => onChangeQuantity(false)}
                  className='minus bg-dark'
                >
                  -
                </span>
                      <span className='quantity pt-1 px-2'>{selectedItem.quantity}шт.</span>
                      <OverlayTrigger placement='top' overlay={showMaxQuantityTooltip ? (<Tooltip id='tooltip'>
                        <strong>Обрано максимальну кількість, більше немає в наявності</strong>
                      </Tooltip>) : (<span></span>)}>
                  <span
                    onClick={() => onChangeQuantity(true)}
                    className='plus bg-dark'
                  >
                    +
                  </span>
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
              )}
              <div className="pt-3">
                {successAPIMessageModal && <div className='alert alert-success mb-0' role='alert'>{successAPIMessageModal}</div>}
                {errorAPIMessageModal && <div className='alert alert-danger mb-0' role='alert'>{errorAPIMessageModal}</div>}
              </div>
            </div>
            <div className='modal-footer'>
              <button type='button' className='btn btn-secondary' data-dismiss='modal'>Закрити</button>
              <button type='button' className='btn btn-success' onClick={() => handleConfirmProductOrderQuantityEdit()}
                      disabled={disableButtons}>
                Зберегти
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className='modal fade' id='editProductOrderModal' tabIndex='-1' role='dialog'
           aria-labelledby='editProductOrderModalLabel'
           aria-hidden='true'>
        <div className='modal-dialog modal-dialog-centered' role='document'>
          <div className='modal-content'>
            <div className='modal-header'>
              {selectedItem && (
                <h5 className='modal-title font-weight-bold' id='editModalLabel'>Редагування: {selectedItem.name}</h5>
              )}
              <button type='button' className='close' data-dismiss='modal' aria-label='Close'>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <div className='modal-body'>
              {selectedItem && (
                <form>
                  <div className='form-group'>
                    <label>Ціна:</label>
                    <input type='number' className='form-control' value={selectedItem.price}
                           onChange={(e) => setSelectedItem({ ...selectedItem, price: e.target.value })} />
                  </div>
                  <div className='form-group'>
                    <label>Ціна зі знижкою:</label>
                    <input type='number' className='form-control' value={selectedItem.discountedPrice}
                           onChange={(e) => setSelectedItem({ ...selectedItem, discountedPrice: e.target.value })} />
                  </div>
                  <div className='form-group'>
                    <label>Ціна закупки:</label>
                    <input type='number' className='form-control' value={purchasePriceLocked ? 0 : selectedItem.purchasePrice ?? 0}
                           disabled={purchasePriceLocked} min='0' step='0.01'
                           onChange={(e) => setSelectedItem({ ...selectedItem, purchasePrice: e.target.value, purchasePriceEdited: true })} />
                    {purchasePriceLocked && <small className='form-text text-muted'>
                      Ціна закупівлі визначається після надходження товару на склад.
                    </small>}
                  </div>
                  <div className='form-group'>
                    <label>Комісія прому:</label>
                    <input type='number' className='form-control' value={selectedItem.promCommission}
                           onChange={(e) => setSelectedItem({ ...selectedItem, promCommission: e.target.value })} />
                  </div>
                  <div className='form-group'>
                    <label>Тип замовлення товару:</label>
                    <select className='form-control'
                            value={selectedItem.productOrderType ? selectedItem.productOrderType.databaseValue : "Не визначено"}
                            onChange={(e) => setSelectedItem({
                              ...selectedItem,
                              productOrderType: { ...selectedItem.productOrderType, databaseValue: e.target.value },
                            })}>
                      {!selectedItem.productOrderType && (
                        <option value="Не визначено">Не визначено</option>
                      )}
                      {poProductOrderTypeEnum.map((type, index) => (
                        <option key={index} value={type.databaseValue}>{type.clientValue}</option>
                      ))}
                    </select>
                  </div>
                  <div className='form-group'>
                    <label>Статус товару:</label>
                    <select className='form-control'
                            value={selectedItem.productStatus ? selectedItem.productStatus.databaseValue : "Не визначено"}
                            onChange={(e) => setSelectedItem({
                              ...selectedItem,
                              productStatus: { ...selectedItem.productStatus, databaseValue: e.target.value },
                            })}>
                      {!selectedItem.productStatus && (
                        <option value="Не визначено">Не визначено</option>
                      )}
                      {poProductStatusEnum.map((status, index) => (
                        <option key={index} value={status.databaseValue}>{status.shortValue}</option>
                      ))}
                    </select>
                  </div>
                  <div className='form-group'>
                    <label>Прогнозована дата надходження:</label>
                    <input type='date' className='form-control'
                           value={toDateInputValue(selectedItem.expectedArrivalDate)}
                           onChange={(e) => setSelectedItem({ ...selectedItem, expectedArrivalDate: e.target.value })} />
                  </div>
                </form>
              )}
              {successAPIMessageModal && <div className='alert alert-success mb-0' role='alert'>{successAPIMessageModal}</div>}
              {errorAPIMessageModal && <div className='alert alert-danger mb-0' role='alert'>{errorAPIMessageModal}</div>}
            </div>
            <div className='modal-footer'>
              <button type='button' className='btn btn-secondary' data-dismiss='modal'>Закрити</button>
              <button type='button' className='btn btn-success'
                      onClick={() => handleConfirmProductOrderEdit()}
                      disabled={disableButtons}>
                Зберегти
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className='modal fade' id='editDeliveryModal' tabIndex='-1' role='dialog'
           aria-labelledby='editDeliveryModalLabel'
           aria-hidden='true'>
        <div className='modal-dialog modal-dialog-centered' role='document'>
          <div className='modal-content'>
            <div className='modal-header'>
              {editedUserInfo && (
                <h5 className='modal-title font-weight-bold' id='editDeliveryModalLabel'>Редагування даних для
                  доставки</h5>
              )}
              <button type='button' className='close' data-dismiss='modal' aria-label='Close'>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <div className='modal-body'>
              {editedUserInfo && (
                <div>
                  <div className='form-group'>
                    <label>Ім’я:</label>
                    <input type='text' className='form-control' value={editedUserInfo.name}
                           onChange={(e) => setEditedUserInfo({ ...editedUserInfo, name: e.target.value })} />
                  </div>
                  <div className='form-group'>
                    <label>Прізвище:</label>
                    <input type='text' className='form-control' value={editedUserInfo.surname}
                           onChange={(e) => setEditedUserInfo({ ...editedUserInfo, surname: e.target.value })} />
                  </div>
                  <div className='form-group'>
                    <label>Телефон:</label>
                    <input type='text' className='form-control' value={editedUserInfo.phone}
                           onChange={handlePhoneNumberChange} />
                  </div>

                  <div className='form-group mb-3'>
                    <label htmlFor='receiveMethod'>Спосіб отримання</label>
                    <select
                      className='form-control'
                      id='receiveMethod'
                      onChange={handleReceiveMethodChange}
                      value={selectedReceiveMethod ? selectedReceiveMethod.id : ''}
                    >
                      {!selectedReceiveMethod && (
                        <option value='' disabled hidden>
                          Оберіть спосіб отримання
                        </option>
                      )}
                      {receiveMethods.map(method => (
                        <option key={method.id} value={method.id}>
                          {method.description}
                        </option>
                      ))}
                    </select>
                  </div>

                  {selectedReceiveMethod && (
                    <div>
                      {selectedReceiveMethod.id !== 3 && (
                        <NovaPostCityInput
                          value={editedUserInfo.city}
                          onCityChange={(suggestion) => setEditedUserInfo({
                            ...editedUserInfo,
                            city: suggestion.present,
                            novaPostCityRef: suggestion.ref,
                            novaPostDeliveryCityRef: suggestion.deliveryCity
                          })}
                        />
                      )}

                      {selectedReceiveMethod.id === 1 && (
                        <NovaPostDepartmentInput
                          value={editedUserInfo.departmentNumber}
                          onDepartmentChange={(suggestion) => setEditedUserInfo({
                            ...editedUserInfo,
                            departmentNumber: suggestion.description,
                            novaPostAddressRef: suggestion.ref,
                          })}
                          novaPostCityRef={editedUserInfo.novaPostCityRef}
                          novaPostDeliveryCityRef={editedUserInfo.novaPostDeliveryCityRef}
                          cityName={editedUserInfo.city}
                        />
                      )}

                      {selectedReceiveMethod.id === 2 && (
                        <NovaPostAddressInput
                          street={editedUserInfo.street}
                          buildingNumber={editedUserInfo.buildingNumber}
                          flatNumber={editedUserInfo.flatNumber}
                          onStreetChange={(suggestion) => setEditedUserInfo({
                            ...editedUserInfo,
                            street: suggestion.street,
                            novaPostStreetRef: suggestion.ref,
                          })}
                          onBuildingNumberChange={(buildingNumber) => setEditedUserInfo({
                            ...editedUserInfo,
                            buildingNumber: buildingNumber
                          })}
                          onFlatNumberChange={(flatNumber) => setEditedUserInfo({
                            ...editedUserInfo,
                            flatNumber: flatNumber
                          })}
                          novaPostCityRef={editedUserInfo.novaPostCityRef}
                          novaPostDeliveryCityRef={editedUserInfo.novaPostDeliveryCityRef}
                          cityName={editedUserInfo.city}/>
                      )}
                    </div>
                  )}
                </div>
              )}
              {successAPIMessageModal && <div className='alert alert-success mb-0' role='alert'>{successAPIMessageModal}</div>}
              {errorAPIMessageModal && <div className='alert alert-danger mb-0' role='alert'>{errorAPIMessageModal}</div>}
            </div>
            <div className='modal-footer'>
              <button type='button' className='btn btn-secondary' data-dismiss='modal'>Закрити</button>
              <button type='button' className='btn btn-success' onClick={() => handleConfirmDeliveryEdit()}
                      disabled={disableButtons}>
                Зберегти
              </button>
            </div>
          </div>
        </div>
      </div>

      {order && (
        <AttachUserModal
          orderId={order.orderId}
          attachedUserId={order.userId}
          onAttachSuccess={() => {
            getOrderInfo();
            setSuccessAPIMessage('Користувача прикріплено до замовлення');
            setErrorAPIMessage('');
            // Автоматично приховуємо повідомлення через 2 секунди
            setTimeout(() => {
              setSuccessAPIMessage('');
            }, 2000);
          }}
          token={token}
        />
      )}

      <div className='modal fade' id='selectWeightModal' tabIndex='-1' role='dialog'
           aria-labelledby='selectWeightModalLabel' aria-hidden='true'>
        <div className='modal-dialog modal-dialog-centered create-shipment-modal' role='document'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title font-weight-bold'>Створення накладної</h5>
              <button type='button' className='close' data-dismiss='modal' aria-label='Закрити'>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <div className='modal-body'>
              <div className='form-group'>
                <label className='font-weight-bold'>Хто сплачує доставку</label>
                <div className='d-flex border border-dark rounded' style={{ maxWidth: 280 }}>
                  <div
                    role='button'
                    tabIndex={0}
                    aria-disabled={isDeliveryPayerLocked}
                    className={`flex-fill text-center py-2 px-3 rounded-left ${isDeliveryPayerLocked ? '' : 'cursor-pointer'} ${deliveryPayer === 'Sender' ? 'bg-dark text-white' : 'bg-light text-dark'}`}
                    style={isDeliveryPayerLocked ? { cursor: 'not-allowed', opacity: 0.9 } : undefined}
                    onClick={() => setDeliveryPayerIfAllowed('Sender')}
                    onKeyDown={(e) => e.key === 'Enter' && setDeliveryPayerIfAllowed('Sender')}
                  >
                    Відправник
                  </div>
                  <div
                    role='button'
                    tabIndex={0}
                    aria-disabled={isDeliveryPayerLocked}
                    className={`flex-fill text-center py-2 px-3 rounded-right ${isDeliveryPayerLocked ? '' : 'cursor-pointer'} ${deliveryPayer === 'Recipient' ? 'bg-dark text-white' : 'bg-light text-dark'}`}
                    style={isDeliveryPayerLocked ? { cursor: 'not-allowed', opacity: 0.9 } : undefined}
                    onClick={() => setDeliveryPayerIfAllowed('Recipient')}
                    onKeyDown={(e) => e.key === 'Enter' && setDeliveryPayerIfAllowed('Recipient')}
                  >
                    Отримувач
                  </div>
                </div>
                {isDeliveryPayerLocked && (
                  <div className='small text-muted mt-1'>
                    Для оплати карткою від 2000 грн доставку оплачує відправник.
                  </div>
                )}
              </div>
              <hr style={{ borderColor: 'rgba(0,0,0,0.08)' }} />

              {places.map((place, placeIndex) => (
                <div key={placeIndex} className='form-group'>
                  <div className='d-flex align-items-center justify-content-between mb-1'>
                    <label className='font-weight-bold mb-0'>
                      {places.length === 1 ? 'Оберіть пакування' : `Місце ${placeIndex + 1} - оберіть пакування`}
                    </label>
                    {placeIndex > 0 && (
                      <button
                        type='button'
                        className='btn btn-link p-0 text-danger'
                        onClick={() => removePlace(placeIndex)}
                        title='Видалити місце'
                        aria-label='Видалити місце'
                      >
                        <i className='bi bi-trash-fill' />
                      </button>
                    )}
                  </div>
                  <div className='position-relative'>
                    <button
                      type='button'
                      className='form-control d-flex align-items-center text-left bg-white border'
                      style={{ minHeight: 40 }}
                      onClick={() => setPlaces(prev => prev.map((p, i) => ({ ...p, dropdownOpen: i === placeIndex ? !p.dropdownOpen : false })))}
                    >
                      {place.isCustom ? (
                        <span className='text-muted'>Ввести габарити вручну</span>
                      ) : place.selectedBox && place.selectedBox.awsImageName ? (
                        <>
                          <img
                            src={BASE_URL + '/api/v1/product/image/' + place.selectedBox.awsImageName}
                            alt=''
                            className='mr-2'
                            style={{ height: 28, width: 34, objectFit: 'contain' }}
                          />
                          <span>{place.selectedBox.description}</span>
                        </>
                      ) : place.selectedBox && place.selectedBox.id ? (
                        <span>{place.selectedBox.description}</span>
                      ) : (
                        <span className='text-muted'>Оберіть пакування</span>
                      )}
                      <i className='bi bi-chevron-down ml-auto' style={{ transition: 'transform 0.2s', transform: place.dropdownOpen ? 'rotate(180deg)' : 'none' }} />
                    </button>
                    {place.dropdownOpen && (
                      <div className='border rounded shadow-sm bg-white position-absolute w-100 mt-1' style={{ zIndex: 1050, maxHeight: 220, overflowY: 'auto' }}>
                        <div
                          className='p-2 d-flex align-items-center border-bottom'
                          style={{ cursor: 'pointer' }}
                          onMouseEnter={(e) => e.currentTarget.classList.add('bg-light')}
                          onMouseLeave={(e) => e.currentTarget.classList.remove('bg-light')}
                          onClick={() => {
                            setPlace(placeIndex, { selectedBox: {}, isCustom: true, dropdownOpen: false });
                            setErrorAPIMessage('');
                          }}
                        >
                          <span className='text-muted ml-2'>Ввести габарити вручну</span>
                        </div>
                        {packagingBoxesOptions && packagingBoxesOptions.map((box) => (
                          <div
                            key={box.id}
                            className='p-2 d-flex align-items-center border-bottom'
                            style={{ cursor: 'pointer' }}
                            onMouseEnter={(e) => e.currentTarget.classList.add('bg-light')}
                            onMouseLeave={(e) => e.currentTarget.classList.remove('bg-light')}
                            onClick={() => {
                              setPlace(placeIndex, { selectedBox: box, isCustom: false, dropdownOpen: false });
                              setErrorAPIMessage('');
                            }}
                          >
                            {box.awsImageName && (
                              <img
                                src={BASE_URL + '/api/v1/product/image/' + box.awsImageName}
                                alt=''
                                className='mr-2 flex-shrink-0'
                                style={{ height: 28, width: 34, objectFit: 'contain' }}
                              />
                            )}
                            <span>{box.description}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  {place.isCustom && (
                    <div className='row mt-2'>
                      <div className='col-lg-4 col-md-4 col-sm-12'>
                        <label className='font-weight-bold'>Довжина (см)</label>
                        <input type='number' className='form-control' name='length'
                               value={place.selectedBox?.length ?? ''} onChange={(e) => handleCustomBoxChange(placeIndex, e)} />
                      </div>
                      <div className='col-lg-4 col-md-4 col-sm-12'>
                        <label className='font-weight-bold'>Ширина (см)</label>
                        <input type='number' className='form-control' name='width'
                               value={place.selectedBox?.width ?? ''} onChange={(e) => handleCustomBoxChange(placeIndex, e)} />
                      </div>
                      <div className='col-lg-4 col-md-4 col-sm-12'>
                        <label className='font-weight-bold'>Висота (см)</label>
                        <input type='number' className='form-control' name='height'
                               value={place.selectedBox?.height ?? ''} onChange={(e) => handleCustomBoxChange(placeIndex, e)} />
                      </div>
                      <div className='col-12'>
                        <label className='font-weight-bold'>Вага (кг)</label>
                        <input type='number' className='form-control' name='weight'
                               value={place.selectedBox?.weight ?? ''} onChange={(e) => handleCustomBoxChange(placeIndex, e)}
                               placeholder="Не обов'язково" />
                      </div>
                    </div>
                  )}
                </div>
              ))}

              <div className='form-group mb-2'>
                <button type='button' className='btn btn-link p-0 text-primary font-weight-bold' onClick={addPlace}>
                  Додати місце
                </button>
              </div>

              <hr style={{ borderColor: 'rgba(0,0,0,0.08)' }} />

              <div className='form-group'>
                <label className='font-weight-bold'>Встановити опис</label>
                <input
                  type='text'
                  className='form-control'
                  value={shipmentDescription}
                  onChange={(e) => setShipmentDescription(e.target.value)}
                  placeholder='Наприклад: Wargame Shop замовлення #123 або подарунок'
                />
              </div>
              {(successAPIMessage || errorAPIMessage) && (
                <div className={errorAPIMessage ? 'alert alert-danger mt-3 mb-0' : 'alert alert-success mt-3 mb-0'} role='alert'>
                  {successAPIMessage || errorAPIMessage}
                </div>
              )}
            </div>
            <div className='modal-footer'>
              {order && !order.trackingNumber && order.userInfo.receiveMethod.id !== 3 && (
                <button type='button' className='btn btn-dark w-100' onClick={createShipment} disabled={isLoading}>
                  {isLoading ? 'Завантаження...' : 'Створити накладну'}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className='modal fade' id='deleteShipmentModal' tabIndex='-1' role='dialog'
           aria-labelledby='deleteShipmentModalLabel' aria-hidden='true'>
        <div className='modal-dialog modal-dialog-centered' role='document'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title font-weight-bold' id='deleteShipmentModalLabel'>
                {deleteShipmentResult == null ? 'Видалити накладну' : (deleteShipmentResult.success ? 'Результат' : 'Помилка')}
              </h5>
              <button type='button' className='close' data-dismiss='modal' aria-label='Закрити' onClick={closeDeleteShipmentModal}>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <div className='modal-body py-2 px-3'>
              {deleteShipmentResult == null && !isDeletingShipment && (
                <p className='mb-0'>
                  Видалити накладну з кабінету Нової Пошти, з бази даних та з таблиці упаковок? Цю дію не можна скасувати.
                </p>
              )}
              {isDeletingShipment && (
                <p className='mb-0'>Видалення...</p>
              )}
              {deleteShipmentResult != null && !isDeletingShipment && (
                <div className={deleteShipmentResult.success ? 'alert alert-success' : 'alert alert-danger'} role='alert'>
                  {deleteShipmentResult.message}
                </div>
              )}
            </div>
            <div className='modal-footer py-2 px-3'>
              {deleteShipmentResult == null ? (
                <button type='button' className='btn btn-dark w-100' onClick={confirmDeleteShipment} disabled={isDeletingShipment}>
                  {isDeletingShipment ? 'Видалення...' : 'Видалити'}
                </button>
              ) : (
                <button type='button' className='btn btn-dark w-100' data-dismiss='modal' onClick={closeDeleteShipmentModal}>
                  Закрити
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      <BulkOrderDiscountModal
        show={showBulkDiscountModal}
        onClose={() => !bulkDiscountLoading && setShowBulkDiscountModal(false)}
        selectedCount={selectedOrderItemKeys.length}
        forceDiscount={bulkForceDiscount}
        onForceDiscountChange={() => setBulkForceDiscount(!bulkForceDiscount)}
        discountLevelsList={bulkDiscountLevelsList}
        selectedDiscountLevel={bulkSelectedDiscountLevel}
        onDiscountLevelChange={(e) => setBulkSelectedDiscountLevel(e.target.value)}
        discountPercent={bulkDiscountPercent}
        onDiscountPercentChange={(e) => setBulkDiscountPercent(e.target.value)}
        token={token}
        discountSelectedUser={bulkDiscountSelectedUser}
        discountUserSearchQuery={bulkDiscountUserSearchQuery}
        onDiscountUserSearchQueryChange={onBulkDiscountUserSearchQueryChange}
        onDiscountUserSelect={onBulkDiscountUserSelect}
        onDiscountUserClear={onBulkDiscountUserClear}
        onApply={applyBulkDiscount}
        loading={bulkDiscountLoading}
        message={bulkDiscountMessage}
        errorMessage={bulkDiscountErrorMessage}
      />

      <div className='content d-none d-lg-block font-size-15px'>
        {order === null ? (
          <h5 className='text-center font-weight-bold pt-2 text-danger'>Замовлення не знайдено</h5>
        ) : (
          <AdminOrderDesktopView
            order={order}
            onPromoChanged={() => { setPaymentRefreshKey(value => value + 1); return getOrderInfo(); }}
            orderStatusesEnum={availableOrderStatuses}
            paymentTypesEnum={paymentTypesEnum}
            paymentStatusesEnum={paymentStatusesEnum}
            getOrderInfo={getOrderInfo}
            handleOrderStatusChange={changeOrderStatus}
            handlePaymentTypeChange={changePaymentType}
            handlePaymentStatusChange={changePaymentStatus}
            renderGenerateMessageToClipboardIcon={renderGenerateMessageToClipboardIcon}
            renderGeneratePreorderMessageToClipboardIcon={renderGeneratePreorderMessageToClipboardIcon}
            renderGeneratePreorderSoonMessageToClipboardIcon={renderGeneratePreorderSoonMessageToClipboardIcon}
            renderGenerateDeliveryConfirmationMessageToClipboardIcon={renderGenerateDeliveryConfirmationMessageToClipboardIcon}
            setModalImage={setModalImage}
            handleEditProductOrderButtonClick={handleEditProductOrderButtonClick}
            renderUserComment={renderUserComment}
            renderAdminComment={renderAdminComment}
            renderPrice={renderPrice}
            handleEditDeliveryInfoButtonClick={handleEditDeliveryInfoButtonClick}
            copyToClipboard={copyToClipboard}
            detachOrderFromUser={detachOrderFromUser}
            disableButtons={disableButtons}
            successAPIMessage={successAPIMessage}
            errorAPIMessage={errorAPIMessage}
            onOpenCreateShipmentModal={openCreateShipmentModal}
            onOpenDeleteShipmentModal={closeDeleteShipmentModal}
            onOpenScannerPick={() => setShowScannerPickModal(true)}
            paymentRefreshKey={paymentRefreshKey}
            {...orderItemActions}
          />
        )}
      </div>

      <div className='content-mobile d-lg-none font-size-15px'>
        {order === null ? (
          <h5 className='text-center font-weight-bold pt-2 text-danger'>Замовлення не знайдено</h5>
        ) : (
          <AdminOrderMobileView
            {...orderItemActions}
            paymentRefreshKey={paymentRefreshKey}
            order={order}
            onPromoChanged={() => { setPaymentRefreshKey(value => value + 1); return getOrderInfo(); }}
            orderStatusesEnum={availableOrderStatuses}
            paymentTypesEnum={paymentTypesEnum}
            paymentStatusesEnum={paymentStatusesEnum}
            getOrderInfo={getOrderInfo}
            handleOrderStatusChange={changeOrderStatus}
            handlePaymentTypeChange={changePaymentType}
            handlePaymentStatusChange={changePaymentStatus}
            renderGenerateMessageToClipboardIcon={renderGenerateMessageToClipboardIcon}
            renderGeneratePreorderMessageToClipboardIcon={renderGeneratePreorderMessageToClipboardIcon}
            renderGeneratePreorderSoonMessageToClipboardIcon={renderGeneratePreorderSoonMessageToClipboardIcon}
            renderGenerateDeliveryConfirmationMessageToClipboardIcon={renderGenerateDeliveryConfirmationMessageToClipboardIcon}
            setModalImage={setModalImage}
            handleEditProductOrderButtonClick={handleEditProductOrderButtonClick}
            renderUserComment={renderUserComment}
            renderAdminComment={renderAdminComment}
            renderPrice={renderPrice}
            handleEditDeliveryInfoButtonClick={handleEditDeliveryInfoButtonClick}
            copyToClipboard={copyToClipboard}
            detachOrderFromUser={detachOrderFromUser}
            disableButtons={disableButtons}
            successAPIMessage={successAPIMessage}
            errorAPIMessage={errorAPIMessage}
            onOpenCreateShipmentModal={openCreateShipmentModal}
            onOpenDeleteShipmentModal={closeDeleteShipmentModal}
            onOpenScannerPick={() => setShowScannerPickModal(true)}
          />
        )}
      </div>

      <InvoiceBuyerModal
        show={showInvoiceBuyerModal}
        onClose={() => !isExportingOrderInvoice && setShowInvoiceBuyerModal(false)}
        onConfirm={confirmOrderInvoiceExport}
        loading={isExportingOrderInvoice}
        ordersCount={1}
        initialBuyer={order ? buildBuyerFromOrder(order) : ''}
        exportError={invoiceExportError}
      />

      <div className='row'>
        <div className='col p-0'>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default AdminOrderPage;
